import { createContext } from 'react';
import type { TTermsContextValue } from './Terms.types.ts';

export const TermsContext = createContext<TTermsContextValue | undefined>(
  undefined,
);
